import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { App, Modal } from 'antd';

import SelectWithFetchNext from '../../../shared/components/select-with-fetch-next';

import { isBoolean } from 'lodash';
import * as actions from '../store/actions';

import { ChatFilterTypeEnum } from '../../../shared/constants/enums';
import { AppDispatch, RootState } from '../../../store';
import { ChatsCollection, InsuredPhone, MessagesCollection, SmsChat } from '../models';

export type CreateNewChatModalProps = {
  visible: boolean;
  setSearchValue: (value: string) => void;
  updateMessageControl: () => void;
  closeModal: () => void;
  setPageNumber: (page: number) => void;
  setFetchChatData: (props: {
    pageNumber: number;
    chatSearchValue: string;
    callback: (chatObjectList: ChatsCollection) => void;
    filter: ChatFilterTypeEnum;
  }) => void;
  chatFilterValue: ChatFilterTypeEnum;
};

const CreateNewChatModal = ({
  visible,
  setSearchValue,
  updateMessageControl,
  closeModal,
  setPageNumber,
  setFetchChatData,
  chatFilterValue,
}: CreateNewChatModalProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { message } = App.useApp();

  const [loadingIndicator, setLoadingIndicator] = useState<() => void>();

  const { checkExistedChatResultLoading, localChats } = useSelector((state: RootState) => state.smsChat);

  const { messageControlParameters } = useSelector((state: RootState) => state.smses);

  useEffect(() => {
    if (checkExistedChatResultLoading) {
      const hide = message.loading('Action in progress..', 0);
      setLoadingIndicator(() => hide);
    } else {
      loadingIndicator?.();
    }
  }, [checkExistedChatResultLoading]);

  const onNewChatItemSelect = (objectValue: InsuredPhone) => {
    if (!messageControlParameters) {
      return;
    }
    const index = localChats?.chatList.findIndex(
      (x: SmsChat) => x.phoneNumber.replace('+1', '').replace(/\D/g, '') === objectValue.value.replace('+1', '').replace(/\D/g, ''),
    );

    if (index && index > -1) {
      dispatch(actions.setSelectedChatItem(localChats?.chatList[index]));
      updateMessageControl();
      closeModal();
    } else {
      dispatch(
        actions.checkExistedChat({
          toNumber: objectValue.value.replace('+1', '').replace(/\D/g, ''),
          smsServiceType: messageControlParameters.smsServiceType,
          ownerAccountUserId: messageControlParameters.ownerAccountUserId,
          myPhoneNumber: messageControlParameters.myNumber,
        }),
      ).then((result) => {
        if (isBoolean(result) && result === true) {
          let searchNewValue = objectValue.value.replace('+1', '').replace(/\D/g, '');
          setSearchValue(searchNewValue);
          setPageNumber(1);
          dispatch(
            actions.setLocalChats({
              hasMore: true,
              chatList: [],
              lastChangeDateTime: null,
            }),
          );
          if (typeof setFetchChatData === 'function') {
            setFetchChatData({
              pageNumber: 1,
              chatSearchValue: searchNewValue,
              callback: (chatObjectList: ChatsCollection) => {
                dispatch(actions.setSelectedChatItem(chatObjectList.chatList[0]));
                updateMessageControl();
                closeModal();
              },
              filter: chatFilterValue,
            });
          }
        } else {
          dispatch(
            actions.setSelectedChatItem({
              phoneNumber: objectValue.value,
              chatName: objectValue.insuredName,
              truckingCompanyId: objectValue.insuredId,
              truckingCompanyType: objectValue.truckingCompanyType,
            } as SmsChat),
          );
          closeModal();
          dispatch(actions.setLocalMessages({} as MessagesCollection));
        }
      });
    }
  };

  return (
    <Modal open={visible} title="Create new chat" centered onCancel={closeModal} onOk={closeModal} footer={<></>}>
      <SelectWithFetchNext
        onSelect={onNewChatItemSelect}
        dropdownMatchSelectWidth={false}
        keyName={'id'}
        titleName={'display'}
        textName={'display'}
        fetchNext={actions.getInsuredsPhones}
        placeholder="Select or type phone"
        createNewItemIfSearchNotExist
        className={'create-new-chat-select-phone'}
      />
    </Modal>
  );
};

export default CreateNewChatModal;
